<template>
  <div class="common_header">
    <span>{{ title }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: '标题'
      }
    }
  }
</script>

<style lang="less" scoped>
  .common_header {
    height: 5vh;
    position: relative;
    background-image: url('./img/common_header.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;

    span {
      position: absolute;
      top: 0.43vh;
      left: 0.69rem;
      font-family: SourceHanSansCN-Light;
      font-size: 1.67vh;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pumpMonitor/commonHeader.vue